import { memo, useEffect, useRef, useState } from 'react'

import { Caption } from '@/shared/components/typography'

import { backgrounds } from '@/styles/shared/button'

type TabProps = {
  currentSeq: string
  tab: string
  isActive: boolean
  setTabCenter: (tabCenterX: number) => void
}

const Tab = ({ tab, isActive, setTabCenter, currentSeq }: TabProps) => {
  const tabRef = useRef<HTMLDivElement | null>(null)
  const [target, setTarget] = useState<HTMLDivElement | null>(null)

  const onTabClick = () => {
    const tab = tabRef.current
    if (!tab) return

    const { left, right } = tab.getBoundingClientRect()
    const tabCenterX = (left + right) / 2

    setTabCenter(tabCenterX)
  }

  useEffect(() => {
    const tab = tabRef.current
    if (!tab) return

    if (tab.classList.contains('active')) {
      setTarget(tab)
    }
  }, [currentSeq])

  useEffect(() => {
    if (!target) return

    const { left, right } = target.getBoundingClientRect()
    const tabCenterX = (left + right) / 2

    setTabCenter(tabCenterX)
  }, [target])

  return (
    <div className="mr-5 flex shrink-0 cursor-pointer first:ml-6 last:after:mr-6" onClick={onTabClick}>
      <span
        ref={tabRef}
        className={`block rounded-md py-0.5 transition-all ${isActive ? `active ${backgrounds['main040']}` : ''} ${
          isActive ? 'px-3' : ''
        }`}
      >
        <Caption
          className={`block max-w-[180px] overflow-hidden text-ellipsis whitespace-nowrap`}
          level="caption2"
          color="white"
          weight={isActive ? 'medium' : 'regular'}
        >
          {tab}
        </Caption>
      </span>
    </div>
  )
}

export default memo(Tab)
